import { alpha, PaletteOptions } from '@mui/material';

export type Color = (
  'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning'
);

declare module "@mui/material/styles" {
  interface Palette {
    alert: {
      error: {
        background: string,
      },
      info: {
        background: string,
      },
      success: {
        background: string,
      },
      warning: {
        background: string,
      },
    },
    outline: string,
    primaryContainer: string,
    rewardsYellow: string,
    rewardsCyan: string,
    surface2: string,
    churnStatus?: {
      high: {
        main: string;
        contrastText?: string;
      };
      moderate: {
        main: string;
        contrastText?: string;
      };
      low: {
        main: string;
        contrastText?: string;
      };
      insufficient: {
        main: string;
        contrastText?: string;
      };
    };
  }

  interface PaletteOptions {
    alert: {
      error: {
        background: string,
      },
      info: {
        background: string,
      },
      success: {
        background: string,
      },
      warning: {
        background: string,
      },
    },
    outline?: string,
    primaryContainer?: string,
    rewardsYellow?: string,
    rewardsCyan?: string,
    surface2?: string,
    churnStatus?: {
      high: {
        main: string;
        contrastText?: string;
      };
      moderate: {
        main: string;
        contrastText?: string;
      };
      low: {
        main: string;
        contrastText?: string;
      };
      insufficient: {
        main: string;
        contrastText?: string;
      };
    };
  }
}

export const DarkPalette: PaletteOptions = {
  mode: 'dark',
  primary: {
    main: '#EDF354',
  },
  secondary: {
    main: '#EDF354',
  },
  background: {
    default: '#181817',
  },
  error: {
    main: '#FFA198',
  },
  success: {
    main: '#8FD460',
  },
  warning: {
    main: '#FFA940',
  },
  info: {
    main: '#8DCFF8',
  },
  divider: '#3F3E38',
  alert: {
    error: {
      background: '#160B0B',
    },
    info: {
      background: '#071318',
    },
    success: {
      background: '#0C130D',
    },
    warning: {
      background: '#191207',
    },
  },
  rewardsYellow: '#FFDD56',
  rewardsCyan: '#C1FFFF',
  churnStatus: {
    high: { 
      main : '#D70D09',
      contrastText : "#FFFFFF",
    },
    moderate: { 
      main : '#FFA620',
    },
    low: { 
      main : '#F8D904',
    },
    insufficient: { 
      main : '#E0E0E0',
    },
  },
};

export const LightPalette: PaletteOptions = {
  mode: 'light',
  primary: {
    main: '#67790F',
  },
  secondary: {
    main: '#141414',
  },
  background: {
    default: '#FCFCFC',
    paper: '#FFFFFF',
  },
  error: {
    main: '#D70D09',
  },
  success: {
    main: '#2F8F07',
  },
  warning: {
    main: '#FF9900',
  },
  info: {
    main: '#016FD5',
  },
  divider: '#0000001F',
  text: {
    disabled: '#BFBFBF',
    primary: '#141414',
    secondary: '#525252',
  },
  /** Custom Colors **/
  alert: {
    error: {
      background: '#FDEDED',
    },
    info: {
      background: '#E5F6FD',
    },
    success: {
      background: '#EDF7ED',
    },
    warning: {
      background: '#FFF4E5',
    },
  },
  outline: '#E0E0E0',
  primaryContainer: alpha('#67790F', .18),
  rewardsYellow: '#FFDD56',
  rewardsCyan: '#C1FFFF',
  surface2: '#F7F7F7',
  churnStatus: {
    high: { 
      main : '#D70D09',
      contrastText : "#FFFFFF",
    },
    moderate: { 
      main : '#FFA620',
    },
    low: { 
      main : '#F8D904',
    },
    insufficient: { 
      main : '#E0E0E0',
    },
  },
};
